import { render, staticRenderFns } from "./socialintell.vue?vue&type=template&id=24860282&scoped=true&"
import script from "./socialintell.vue?vue&type=script&lang=js&"
export * from "./socialintell.vue?vue&type=script&lang=js&"
import style0 from "./socialintell.vue?vue&type=style&index=0&id=24860282&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24860282",
  null
  
)

export default component.exports